// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__4bQxZ","list":"styles_list__2DGnp"};